import { render } from "./LocalizationsIntegrationSettings.vue?vue&type=template&id=55635f66&scoped=true"
import script from "./LocalizationsIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./LocalizationsIntegrationSettings.vue?vue&type=script&lang=js"

import "./LocalizationsIntegrationSettings.vue?vue&type=style&index=0&id=55635f66&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55635f66"]])

export default __exports__